import { usePermissions } from "../context/PermissionsProvider";

export function useCan(model, action) {
  const permissions = usePermissions();
  

  if (!permissions) return false; // o true si quieres mostrar mientras carga

  return permissions[model] && permissions[model][action] === true;
}
